import { render, staticRenderFns } from "./showPirceType.vue?vue&type=template&id=cf0155da&scoped=true"
import script from "./showPirceType.vue?vue&type=script&lang=js"
export * from "./showPirceType.vue?vue&type=script&lang=js"
import style0 from "./showPirceType.vue?vue&type=style&index=0&id=cf0155da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0155da",
  null
  
)

export default component.exports